<template>
  <div class="container_page">
    <div style="margin-bottom:12px;display:flex;align-items:center;gap:8px;">
      <a-button type="primary" icon="upload" @click="triggerImport">导入</a-button>
    </div>
    <div class="tag">
      <div
        class="tag-item"
        v-for="(item, index) of tableData"
        :key="item.wordId || index"
      >
        <a-input
          v-if="item.wordId === 0"
          class="tagInput"
          v-model.trim="item.word"
          placeholder="请输入敏感词"
          @blur="handleTranslateTag(item, index)"
          @keyup.enter="handleTranslateTag(item, index)"
          :maxLength="10"
          ref="tagInputRef"
        />
        <span class="tag-text" v-else>{{ item.word }}</span>
        <a-icon
          class="close-btn"
          type="close"
          @click="handleDeleteTag(item, index)"
        />
      </div>
      <a-button
        type="dashed"
        size="small"
        icon="plus"
        @click="handleAddTag"
        :loading="submitLoading"
      >
        添加
      </a-button>
    </div>

    <!-- 导入弹窗 -->
    <a-modal title="导入敏感词" :visible="importModel.flag" width="500px" :footer="null" @cancel="importModel.flag = false">
      <div style="display: flex; flex-direction: column; align-items: center; gap: 16px;">
        <a-button type="link" @click="handleDownloadTemplate">下载导入模板</a-button>
        <div class="import-upload-area" @click="triggerFileSelect"
             style="width: 100%; min-height: 160px; border: 2px dashed #d9d9d9; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer;">
          <div style="font-size: 48px; color: #1890ff; line-height: 1;">+</div>
          <div style="margin-top: 8px; color: #333;">点击上传文件</div>
          <div style="font-size: 12px; color: #999; margin-top: 4px;">支持 .xlsx 格式</div>
        </div>
        <input ref="importFileInput" type="file" accept=".xlsx" style="display:none" @change="handleImport" />
        <div v-if="importModel.selectedFile" style="color: #333;">已选择：{{ importModel.selectedFile.name }}</div>
        <a-button v-if="importModel.selectedFile" type="primary" :loading="importModel.uploading" @click="handleUpload">开始导入</a-button>
      </div>
    </a-modal>

    <!-- 导入结果弹窗 -->
    <a-modal title="导入结果" :visible="importModel.resultVisible" width="500px" :footer="null" @cancel="importModel.resultVisible = false">
      <div style="padding: 16px 0;" v-if="importModel.resultData">
        <div v-if="importModel.resultData.fileUrl" style="margin-bottom: 16px; padding: 12px; background: #fff2f0; border: 1px solid #ffccc7; border-radius: 4px;">
          <div style="color: #ff4d4f; margin-bottom: 8px;">部分数据导入失败，请下载错误文件查看详情：</div>
          <a-button type="primary" size="small" @click="downloadErrorFile(importModel.resultData.fileUrl)">下载错误文件</a-button>
        </div>
        <div style="text-align: center;">
          <a-button @click="importModel.resultVisible = false">关闭</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  getSensitiveWordsApi,
  addSensitiveWordApi,
  deleteSensitiveWordApi,
  importSensitiveWordApi,
  importSensitiveWordTemplateApi,
} from "../../api/index";
export default {
  name: "cardsList",
  data() {
    return {
      filterData: {
        timeDate: [],
        keywords: "",
      },
      tableData: [],
      pageInfo: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      loading: false,
      submitLoading: false, // 新增/删除接口loading
      importModel: {
        flag: false,
        selectedFile: null,
        uploading: false,
        resultVisible: false,
        resultData: null,
      },
    };
  },
  mounted() {
    const storedQuery = localStorage.getItem("cardsList_searchQuery");
    if (storedQuery) {
      this.filterData = JSON.parse(storedQuery);
    }
    this.getData();
  },
  beforeRouteLeave(to, from, next) {
    localStorage.setItem(
      "cardsList_searchQuery",
      JSON.stringify(this.filterData)
    );
    next();
  },
  methods: {
    // 删除标签 增加二次确认
    handleDeleteTag(item, index) {
      this.$confirm({
        title: "提示",
        content: `确定删除违禁词【${item.word}】吗？`,
        okText: "确认",
        cancelText: "取消",
        onOk: async () => {
          this.submitLoading = true;
          try {
            const res = await deleteSensitiveWordApi({
              wordId: item.wordId,
            });
            if (res.resultStatus) {
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.errorMessage || "删除失败");
            }
          } catch (err) {
            console.error(err);
            this.$message.error("接口异常，删除失败");
          } finally {
            this.submitLoading = false;
            this.getData();
          }
        },
      });
    },

    // 新增违禁词提交（失焦/回车）
    async handleTranslateTag(item, index) {
      const word = item.word.trim();
      // 空值拦截
      if (!word) {
        // 清空输入框并移除空新增项
        this.tableData.splice(index, 1);
        return;
      }

      // 校验重复
      const repeat = this.tableData.some(
        (t) => t.word && t.word.trim() === word && t.wordId !== 0
      );
      if (repeat) {
        this.$message.warning("该违禁词已存在！");
        return;
      }

      this.submitLoading = true;
      try {
        const res = await addSensitiveWordApi({ word });
        if (res.resultStatus) {
          this.$message.success("添加成功");
        } else {
          this.$message.error(res.errorMessage || "添加失败");
          // 新增失败移除临时输入框
          this.tableData.splice(index, 1);
        }
      } catch (err) {
        console.error(err);
        this.$message.error("接口异常，添加失败");
        this.tableData.splice(index, 1);
      } finally {
        this.submitLoading = false;
        this.getData();
      }
    },

    // 新增空输入框并自动聚焦
    handleAddTag() {
      this.tableData.push({
        wordId: 0,
        word: "",
      });
      // 下一轮DOM更新后聚焦输入框
      this.$nextTick(() => {
        if (this.$refs.tagInputRef) {
          this.$refs.tagInputRef.focus();
        }
      });
    },

    // 获取列表
    getData() {
      if (this.loading) return;
      this.loading = true;
      getSensitiveWordsApi({})
        .then((res) => {
          if (res.resultStatus) {
            this.tableData = res.resultData.dataList || [];
            this.pageInfo.total = res.resultData.totalNum || 0;
          } else {
            this.tableData = [];
            this.pageInfo.total = 0;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("列表加载失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 导入敏感词
    triggerImport() {
      this.importModel.flag = true;
      this.importModel.selectedFile = null;
      this.importModel.resultData = null;
    },
    triggerFileSelect() {
      this.$refs.importFileInput.value = null;
      this.$refs.importFileInput.click();
    },
    handleImport(e) {
      this.importModel.selectedFile = e.target.files[0] || null;
    },
    async handleUpload() {
      const file = this.importModel.selectedFile;
      if (!file) return;
      const formData = new FormData();
      formData.append('file', file);
      this.importModel.uploading = true;
      try {
        const res = await importSensitiveWordApi(formData);
        if (res.resultStatus) {
          const data = res.resultData || {};
          if (data.fileUrl) {
            this.importModel.resultData = data;
            this.importModel.resultVisible = true;
          } else {
            this.$message.success(`导入成功，共 ${data.totalCount || 0} 条`);
            this.importModel.flag = false;
            this.getData();
          }
        } else {
          this.$message.error(res.errorMessage || '导入失败');
        }
      } catch (err) {
        console.error(err);
        this.$message.error('导入失败');
      } finally {
        this.importModel.uploading = false;
      }
    },
    handleDownloadTemplate() {
      const link = document.createElement('a');
      link.href = 'https://oss.chongmi.online/wxapp/importExcel/敏感词.xlsx';
      link.download = '敏感词导入模板.xlsx';
      link.click();
    },
    downloadErrorFile(url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = '导入错误文件.xlsx';
      link.click();
    },
  },
};
</script>

<style lang="less" scoped>
.tag {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  min-height: 40px;

  .tag-item {
    border-radius: 4px;
    border: 1px solid #2CBD9C;
    display: flex;
    align-items: center;
    position: relative;
    padding: 4px 24px 4px 8px;

    .tagInput {
      width: 160px;
      border: none;
      background: transparent;
      outline: none;
      font-size: 16px;
      padding: 0;


      /deep/ .ant-input:focus {
        box-shadow: none !important;
      }
    }

    .tag-text {
      font-size: 16px;
      white-space: nowrap;
    }

    .close-btn {
      position: absolute;
      top: 50%;
      right: 4px;
      transform: translateY(-50%);
      font-size: 14px;
      color: #999;
      cursor: pointer;
      z-index: 1;

      &:hover {
        color: #f00;
      }
    }
  }
}
</style>
